/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * document_storage_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * API-visible content lifecycle state derived from current document metadata.
 */
export type DocumentContentState =
  (typeof DocumentContentState)[keyof typeof DocumentContentState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentContentState = {
  unknown: 'unknown',
  pending: 'pending',
  ready: 'ready',
} as const;
